import { render, staticRenderFns } from "./DetectedFaultsTime.vue?vue&type=template&id=0734c442"
import script from "./DetectedFaultsTime.vue?vue&type=script&lang=js"
export * from "./DetectedFaultsTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports